import { TradeClosedNotificationComponent } from './../trade-closed-notification/trade-closed-notification.component';
import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ToastrService, ToastPackage } from 'ngx-toastr';
import { ShareService } from '../../services/share.service';
import { WorkspaceServiceService } from '../../services/workspace-service.service';
import { Utils } from 'ag-grid';

@Component({
  selector: '[mobile-trade-closed-notification]',
  template: require('./mobile-trade-closed-notification.component.html'),
  styles: [require('./mobile-trade-closed-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ]),
  ],
})
export class MobileTradeClosedNotificationComponent extends TradeClosedNotificationComponent 
{
  footerHeight: string | undefined;
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, protected shareService: ShareService, protected workspaceService: WorkspaceServiceService) 
  {
    super(toastrService, toastPackage, shareService, workspaceService);
  }
}
